import React, { useEffect, useState } from "react";
import Header_Moblie from "./mo";
import Header_Pc from "./pc";

export const Header = () => {
    const [isShow, setIsShow] = useState<boolean>(false)
    const handleScroll = () => {
        if (window.scrollY > 0) {setIsShow(true);} 
        else {setIsShow(false);}
      };
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {window.removeEventListener("scroll", handleScroll);};
      }, []);
    return(
        <>
        <header className="fixed active">
            <Header_Pc/>
            <Header_Moblie/>
        </header>
        {isShow ?
        <button className="topBtn" onClick={()=>window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <i className="fa-sharp fa-regular fa-arrow-up"></i>
        </button> : ''
        }
        </>
    )
}